<template>
    <div class="faq-section">
        <ElCollapse class="faq-section__list">
            <ElCollapseItem class="faq-section__item"
                            title="Документы"
            >
                Выберите один из предложенных вариантов полиса, и укажите данные для оформления полиса.
                Оплатите картой. 
                <!-- Последующие платежи будут списываться автоматически.
                Вы можете отменить подписку в любой момент здесь.
                При этом договор будет действовать до указанной в нем даты окончания. -->
            </ElCollapseItem>
            <ElCollapseItem class="faq-section__item"
                            title="Тарифы"
            >
                1. Пожар, в соответствии с п. 4.1.1. Правил страхования имущества;
                <br>
                2. Взрыв, в соответствии с п. 4.1.3. Правил страхования имущества;
                <br>
                3. Действие воды, в соответствии с п. 4.1.6 Правил страхования имущества;
                <br>
                4. Удар молнии, в соответствии с п. 4.1.2. Правил страхования имущества;
                <br>
                5. Падение пилотируемых летательных объектов, их частей, в соответствии с п. 4.1.4. Правил
                страхования;
                <br>
                6. Опасные природные явления и процессы, в соответствии с п. 4.1.5. Правил страхования;
                <br>
                7. Посторонние воздействия, в соответствии с п. 4.1.9. Правил страхования;
                <br>
                8. Противоправные действия третьих лиц, в соответствии с п. 4.1.7. Правил страхования.
                <br>
                <br>
                Страховым случаем по страхованию убытков от перерыва в производственной деятельности является
                возникновение у Страхователя в течение срока действия договора страхования финансовых убытков
                (потеря (неполучение) Страхователем чистой прибыли, а также несение текущих постоянных расходов,
                в связи с остановкой или сокращением объема производства продукции, выполнения работ или
                оказания
                услуг в результате нанесенного материального ущерба застрахованному имуществу по рискам 1,2,4 и
                5.
                <br>
                <br>
                Страховым риском по страхованию гражданской ответственности перед третьими лицами
                является предполагаемое наступление ответственности Страхователя (Застрахованного лица)
                вследствие случайного причинения вреда в результате пожара на территории страхования жизни,
                здоровью, имуществу Третьих лиц (Выгодоприобретателей) в связи с осуществлением Страхователем
                (Застрахованным лицом) Застрахованной деятельности.
                <a
                    href="https://zettains.ru/upload/rules/Pravila_KASKO_15_08_2022.pdf?t=1661501309986"
                    target="_blank">Подробнее в правилах
                    страхования</a>
            </ElCollapseItem>
            <ElCollapseItem class="faq-section__item"
                            title="Другое"
            >
                1. Материалы конструктивных элементов (стен и/или перекрытий и/или конструкций кровли) здания,
                строения, в котором расположена территория страхования - ж/бетон, кирпич, металл,
                сэндвич-панели;
                дерево в составе конструктивных элементов отсутствует; в качестве утеплителя стен использованы
                материалы из вспененных пластиков (пенопласт, пенополиуретан и т.п.) и иных материалов групп
                горючести Г2-Г4 согласно ГОСТ 30244-94.
                <br>
                2. Инженерные системы (водопровод, отопление, канализация, электроснабжение) эксплуатируются
                без замены или капремонта более 25 лет;
                <br>
                3. Территория страхования не оборудована исправной автоматической охранной сигнализацией
                с выводом на пульт с круглосуточным контролем и/или на территории страхования присутствует
                круглосуточная физическая охрана (ЧОП, МВД, собственная СБ);
                <br>
                4. Территория страхования не оборудована исправной автоматической пожарной сигнализацией
                (АПС) с выводом сигнала на пульт с круглосуточным контролем, не заключен договор с о
                рганизацией, имеющей лицензию МЧС на обслуживание указанной системы, не осуществляется
                регулярное техническое обслуживание АПС и она находится в не рабочем состоянии.
                <br>
                5. Присутствуют предписания надзорных органов (гостехнадзор, пожнадзор и т.п.)
                <br>
                6. Площадь помещения/здания, заявленного на страхование, превышает 1 000,0 м2
                <br>
                7. Здание/помещение/строение является объектом незавершенного строительства, является ветхим
                или брошенным находится в не пригодном для эксплуатации состоянии, имеет не исправное или
                требующее капитального ремонта инженерных сетей или коммуникаций;
                <br>
                8. Застрахованное производственное и технологическое оборудование, оргтехника, мебель находится
                в не пригодном для эксплуатации состоянии, год ввода в эксплуатацию ранее 2000 года.
                <br>
                9. Здание/помещение/строение является: производственным объектом, складом, жилым помещением,
                индивидуальным жилым домом, подвальным помещением.
                <br>
                10. Движимое имущество и товарно-материальные ценности расположены на открытой площадке.
            </ElCollapseItem>
           
        </ElCollapse>
    </div>
</template>

<script>


export default {
    name: 'TheFaq',
    methods: {
        callCancelToAction() {
            this.$emit('cancel-subscription');
        }
    },
}
</script>

<style scoped lang="scss">
.faq-section {
    &__list {
    }

    &__item {
        @include resetting-vertical-indentation-of-first;

        margin-top: rem($gap-normal);
    }
}
</style>